<template>
  <b-modal
    dialog-class="news-add-modal-wrapper"
    body-class="news-add-modal-body"
    footer-class="news-add-modal-footer"
    header-class="news-add-modal-header"
    modal-class="news-add-modal"
    content-class="news-add-modal-content"
    id="news-add-modal"
    centered
  >
    <template #modal-header="{ close }">
      <subtitle>Добавление новости</subtitle>
      <button class="news-close-button" @click="close()" />
    </template>

    <b-form>
      <label class="news-add-textarea-label" for="news-add-textarea">Описание</label>
      <b-form-textarea
        class="news-add-textarea"
        id="news-add-textarea"
        v-model="form.text"
        placeholder="Введите текст новости"
      />

      <custom-checkbox class="news-add-checkbox" labelText="Скрыть меня как автора" v-model="form.hideMe" />

      <div v-if="form.hideMe == 1">
        <custom-input
          class="news-add-author"
          id="input-author"
          v-model="form.author"
          required
          placeholder="Введите автора"
        />
      </div>
    </b-form>

    <template #modal-footer="{ cancel }">
      <main-button class="news-footer-button" @click="save()"> Сохранить </main-button>
      <main-button color="link" class="news-footer-button" @click="cancel()">Отмена</main-button>
    </template>
  </b-modal>
</template>
<script>
import Subtitle from "../ui/Subtitle.vue";
import Checkbox from "../ui/Checkbox.vue";
import Input from "../ui/Input.vue";
import MainButton from "../ui/MainButton.vue";

export default {
  components: {
    Subtitle,
    "custom-checkbox": Checkbox,
    "custom-input": Input,
    MainButton,
  },
  data() {
    return {
      form: {
        hideMe: false,
        icon: null,
        author: null,
        text: null,
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("profile/news-add", this.form)
        .then((response) => {
          this.$emit("newsAdded", response.data);
          this.$bvModal.hide("news-add-modal");
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style>
.news-add-modal-wrapper {
  min-width: 800px;
}

@media screen and (max-width: 768px) {
  .news-add-modal-wrapper {
    min-width: 80%;
  }
}

.news-add-modal-header {
  border: none;
  padding: 24px 24px 32px;
}

.news-add-modal-body {
  padding: 0 24px 32px;
}

.news-add-textarea {
  min-height: 80px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-3-color);
}

.news-add-textarea-label {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--black-color);
  margin-bottom: 4px;
}

.news-add-checkbox {
  margin-top: 10px;
}

.news-add-author {
  margin-top: 8px;
}

.news-add-modal-footer {
  justify-content: flex-start;
  background-color: var(--background-color);
  padding: 16px 24px;
}
</style>
